module.exports = __webpack_public_path__ + "assets/img/00018.8e01138b.png";